import { gql } from '@apollo/client';

export const SET_CREDENTIALS_VTEX = gql`
  mutation SetVtexCredentials($credentials: VtexCredentialsInput!) {
    setVtexCredentials(credentials: $credentials) {
      __typename
      ... on SetVtexCredentialsSuccess {
        code
        credentials {
          vtexAccountName
          appKey
          appToken
        }
      }
      ... on Error {
        message
        code
      }
    }
  }
`;
